const modelSummaryCache = new Map<string, string>();

export const buildModelSummaryRequestKey = (
  modelName: string,
  modelType: string | undefined,
  outputText: string
): string => JSON.stringify([modelName, modelType || "", outputText]);

export const getCachedModelSummary = (key: string | null): string => {
  if (!key) {
    return "";
  }
  return modelSummaryCache.get(key) || "";
};

export const hasCachedModelSummary = (key: string | null): boolean => {
  if (!key) {
    return false;
  }
  return modelSummaryCache.has(key);
};

export const setCachedModelSummary = (key: string | null, summary: string): void => {
  if (!key) {
    return;
  }

  const normalizedSummary = (summary || "").trim();
  if (!normalizedSummary) {
    modelSummaryCache.delete(key);
    return;
  }

  modelSummaryCache.set(key, summary);
};

export const clearCachedModelSummariesForModel = (modelName: string): void => {
  const normalizedModelName = (modelName || "").trim();
  if (!normalizedModelName) {
    return;
  }

  Array.from(modelSummaryCache.keys()).forEach((key) => {
    try {
      const parsedKey = JSON.parse(key);
      if (Array.isArray(parsedKey) && parsedKey[0] === normalizedModelName) {
        modelSummaryCache.delete(key);
      }
    } catch {
      // Ignore malformed cache keys and leave them untouched.
    }
  });
};
